/* eslint-disable @typescript-eslint/no-this-alias */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { Auth } from 'app/scripts/db/Auth';
import { ModelLoader } from 'app/scripts/db/model-loader';
import Payloads from 'app/scripts/network/payloads';
import { maybeDisplayLimitsErrorOnCardAdd } from 'app/scripts/views/card/CardLimitsError';
import { LabelLimitsErrorView } from 'app/scripts/views/label/LabelLimitsErrorView';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { View } from 'app/scripts/views/internal/view';
import _ from 'underscore';
import template from 'app/scripts/views/templates/popover_move_list';
import { l } from 'app/scripts/lib/localize';
import { showFlag } from '@trello/nachos/experimental-flags';

const tooManyCustomFieldsError = 'BOARD_TOO_MANY_CUSTOM_FIELDS';
const tooManyCustomFieldOptionsError = 'CUSTOM_FIELD_TOO_MANY_OPTIONS';

class ListMoveView extends View {
  viewTitleKey = 'move list';

  tagName() {
    return 'form';
  }

  events() {
    return {
      'change .js-select-list-pos': 'renderValues',
      'change .js-select-board': 'updateBoardData',
      'click .js-commit-position': 'commitChange',
      submit: 'commitChange',
    };
  }

  initialize() {
    Analytics.sendScreenEvent({
      name: 'moveListInlineDialog',
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });
  }

  render() {
    const view = this;
    const { model } = view;
    const data = {};

    let currentBoard = this.model.getBoard();
    const enterprise = this.model.getBoard().getEnterprise();
    const me = Auth.me();

    // Don't allow guests on enterprise owned boards to move lists off the current board
    const isGuest = currentBoard.isGuest(me);

    // check if the user is an enterprise member of the same enterprise as the board,
    // they can move lists.
    // Also make sure if this is a non enterprise board and a non enterprise user
    // that it won't return a false positive
    const isEnterpriseMember =
      enterprise /* eslint-disable-line eqeqeq */ != null &&
      me.isManagedEntMemberOf(enterprise.get('id'));

    if (isGuest && currentBoard.get('enterpriseOwned') && !isEnterpriseMember) {
      data.hasEnterprise = true;
      data.enterpriseName = enterprise?.get('displayName');
      data.restrictToCurrentBoard = true;
      data.organizations = [
        {
          displayName:
            currentBoard.getOrganization()?.get('displayName') ||
            l('member boards.boards'),
          boards: [_.extend(currentBoard.toJSON(), { selected: true })],
        },
      ];
    } else if (enterprise /* eslint-disable-line eqeqeq */ != null) {
      data.hasEnterprise = true;
      currentBoard =
        this.model
          .getBoard()
          .getMembershipFor(me) /* eslint-disable-line eqeqeq */ == null
          ? currentBoard
          : null;
      data.organizations = me.getOpenBoardsInEnterpriseByOrg(
        true,
        enterprise.get('id'),
        currentBoard,
      );
      data.enterpriseName = enterprise.get('displayName');
    } else {
      currentBoard = this.model
        .getBoard()
        .isEditableByTeamMemberAndIsNotABoardMember()
        ? currentBoard
        : null;
      data.organizations = me.getOpenBoardsByOrg(true, currentBoard);
    }

    for (const org of data.organizations) {
      for (const board of org.boards) {
        if (board.id === model.get('idBoard')) {
          board.selected = true;
        }
      }
    }

    this.$el.html(template(data));

    this.updateBoardData();

    return this;
  }

  renderValues() {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $el = $(this.el);

    const idBoard = $el.find('.js-select-board option:selected').val();
    const index = parseInt(
      $el.find('.js-select-list-pos option:selected').text(),
      10,
    );

    const board = this.modelCache.get('Board', idBoard);
    const boardName = board.get('name');

    $el.find('.js-board-value').text(boardName);
    $el.find('.js-pos-value').text(String(index));
  }

  updateBoardData() {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $el = $(this.el);
    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectBoard = $el.find('.js-select-board');
    const idBoardSelected = $selectBoard.find('option:selected').val();

    if (idBoardSelected === this.model.getBoard()?.id) {
      this._boardData = this.model.getBoard();

      for (const list of this._boardData.listList.models) {
        list.cardCount = this._boardData.listList
          ?.get(list.id)
          ?.openCards().length;
      }
      this.updateListList();
    } else {
      // eslint-disable-next-line @trello/enforce-variable-case
      const $otherSelects = $el.find('.select-list,.select-position');
      $otherSelects.attr('disabled', 'disabled');
      ModelLoader.loadBoardData(idBoardSelected, Payloads.listsMinimal)
        .then(() => {
          this._boardData = this.modelCache.get('Board', idBoardSelected);
          this.updateListList();
          return $otherSelects.prop('disabled', false);
        })
        .done();
    }
  }

  updateListList() {
    let count, currentIndex;
    const view = this;
    const { model } = view;

    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectList = $('.js-select-list-pos', this.$el);
    $selectList.empty();

    const openLists = this._boardData.listList.models;
    const isCurrentBoard = this._boardData.id === this.model.getBoard().id;

    if (isCurrentBoard) {
      currentIndex = _.indexOf(openLists, this.model);
      count = openLists.length;
    } else {
      currentIndex = -1;
      count = openLists.length + 1;
    }

    for (
      let i = 0, end = count, asc = 0 <= end;
      asc ? i < end : i > end;
      asc ? i++ : i--
    ) {
      const indexString = String(i + 1);
      const desc =
        i === currentIndex
          ? l('current position', { index: indexString })
          : indexString;

      const pos = this._boardData.listList.calcPos(i, model);
      // eslint-disable-next-line @trello/enforce-variable-case
      const $option = $('<option>').val(pos).text(desc).appendTo($selectList);
      if (i === currentIndex) {
        $option.attr('selected', 'selected');
      }
    }

    // eslint-disable-next-line @trello/enforce-variable-case
    const $commitButton = $('.js-commit-position', this.$el);
    // eslint-disable-next-line @trello/enforce-variable-case
    const $limitExceededError = $('.js-list-limit-exceeded', this.$el);

    if (!isCurrentBoard) {
      const traceId = Analytics.startTask({
        taskName: 'edit-list/idBoard',
        source: this.options?.source || 'moveListInlineDialog',
      });

      const tooManyLists =
        this._boardData.isOverLimit('lists', 'totalPerBoard') ||
        this._boardData.isOverLimit('lists', 'openPerBoard');

      $commitButton
        .toggleClass('disabled', tooManyLists)
        .prop('disabled', tooManyLists);

      if (tooManyLists) {
        Analytics.taskFailed({
          taskName: 'edit-list/idBoard',
          source: this.options?.source || 'moveListInlineDialog',
          traceId,
          error: new Error('Exceeded lists limit per board'),
        });
      }

      $limitExceededError.toggleClass('hide', !tooManyLists);
    } else {
      $commitButton.toggleClass('disabled', false).prop('disabled', false);
      $limitExceededError.toggleClass('hide', true);
    }

    return this.renderValues();
  }

  commitChange(e) {
    stopPropagationAndPreventDefault(e);

    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectListPos = $('.js-select-list-pos', this.$el);
    const listPosSelected = parseInt(
      $selectListPos.find('option:selected').val(),
      10,
    );
    const idBoardSelected = $(
      '.js-select-board option:selected',
      this.$el,
    ).val();

    this.model.getBoard().composer.save('vis', false);

    const originalBoardId = this.model.getBoard().id;
    const originalPosition = this.model.get('pos');
    const source = this.options?.source || 'moveListInlineDialog';
    const traceId = Analytics.startTask({
      taskName: 'edit-list/idBoard',
      source: source,
    });

    if (idBoardSelected === originalBoardId) {
      this.model.update({ pos: listPosSelected });

      Analytics.sendTrackEvent({
        action: 'moved',
        actionSubject: 'list',
        source: 'moveListInlineDialog',
        containers: {
          list: {
            id: this.model.id || '',
          },
          board: {
            id: this.model.getBoard()?.id || '',
          },
          organization: {
            id: this.model.getBoard()?.getOrganization()?.id || '',
          },
        },
      });
    } else if (
      idBoardSelected /* eslint-disable-line eqeqeq */ != null &&
      listPosSelected /* eslint-disable-line eqeqeq */ != null
    ) {
      if (this.model.cardList.length > 0) {
        let hasChecklists;
        let hasAttachments = (hasChecklists = false);

        this.model.cardList.forEach((card) => {
          hasAttachments = hasAttachments || card.attachmentList.length > 0;
          hasChecklists = hasChecklists || card.checklistList.length > 0;
        });
        // eslint-disable-next-line @trello/enforce-variable-case
        const $elementTarget = e ? $(e.target) : this.$el;

        const options = {
          $elem: $elementTarget,
          hasChecklists,
          hasAttachments,
          destinationBoard: this._boardData,
        };

        if (maybeDisplayLimitsErrorOnCardAdd(options)) {
          Analytics.taskFailed({
            taskName: 'edit-list/idBoard',
            source: source,
            traceId,
            error: new Error('Exceeded a card limit'),
          });
          return;
        }
      }

      const hasLabels = this.model.cardList.filter(
        (c) => c.getLabels().length > 0,
      );

      if (hasLabels && this._boardData.isOverLimit('labels', 'perBoard')) {
        Analytics.taskFailed({
          taskName: 'edit-list/idBoard',
          source: source,
          traceId,
          error: new Error('Exceeded label limit per board'),
        });
        PopOver.pushView(new LabelLimitsErrorView());
        return;
      }

      const next = (response) => {
        const error = response?.message;
        const source = this.options?.source || 'moveListInlineDialog';

        if (error) {
          this.model.set(
            { idBoard: originalBoardId, pos: originalPosition },
            next,
          );

          Analytics.taskFailed({
            taskName: 'edit-list/idBoard',
            source: source,
            traceId,
            error: error,
          });
        }

        if (error === tooManyCustomFieldsError) {
          Alerts.show('too many custom fields', 'error', 'movelist', 8000);
        } else if (error === tooManyCustomFieldOptionsError) {
          Alerts.show('too many custom options', 'error', 'movelist', 8000);
        } else if (error === 'unauthorized board permission requested') {
          const msg = l('alerts.cannot move list to observer board');
          showFlag({
            id: 'movelist',
            title: msg,
            appearance: 'error',
            isAutoDismiss: true,
            msTimeout: 8000,
          });
        } else if (!error) {
          Analytics.taskSucceeded({
            traceId,
            taskName: 'edit-list/idBoard',
            source: source,
          });

          Analytics.sendTrackEvent({
            action: 'moved',
            actionSubject: 'list',
            source: source,
            attributes: {
              boardSourceId: originalBoardId,
            },
            containers: {
              list: {
                id: this.model.id || '',
              },
              board: {
                id: idBoardSelected || '',
              },
              organization: {
                id: this.model.getBoard()?.getOrganization()?.id || '',
              },
            },
          });
        }
      };

      this.model.update(
        {
          idBoard: idBoardSelected,
          pos: listPosSelected,
        },
        tracingCallback({
          taskName: 'edit-list/idBoard',
          source: source,
          traceId,
        }),
        next,
      );
    }

    PopOver.hide();
  }
}

export { ListMoveView };
